/**
 * Supplement product form — subscribe toggle, pricing, badges, cart drawer boost
 */
(function () {
  'use strict';

  var VARIANT_UPDATE = 'variant:update';
  var CART_UPDATE = 'cart:update';

  function formatMoney(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && format) {
      return Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function initRoot(root) {
    if (!root || root.dataset.supplementInit === 'true') return;
    root.dataset.supplementInit = 'true';

    var dataEl = root.querySelector('[data-supplement-json]');
    if (!dataEl) return;

    var config;
    try {
      config = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var formId = config.formId;
    var productId = String(config.productId);
    var moneyFormat = config.moneyFormat;
    var mode = 'onetime';
    var currentVariantId = config.selectedVariantId;

    var toggleOnetime = root.querySelector('[data-supplement-mode="onetime"]');
    var toggleSubscribe = root.querySelector('[data-supplement-mode="subscribe"]');
    var priceEl = root.querySelector('[data-supplement-price]');
    var compareEl = root.querySelector('[data-supplement-compare]');
    var badgeSave = root.querySelector('[data-supplement-save-badge]');
    var sellingPlanInput = root.querySelector('[data-supplement-selling-plan]');

    var variantMap = {};
    (config.variants || []).forEach(function (v) {
      variantMap[String(v.id)] = v;
    });

    function getForm() {
      return formId ? document.getElementById(formId) : root.closest('.product-information')?.querySelector('form[data-type="add-to-cart-form"]');
    }

    function syncSellingPlanInput(planId) {
      var form = getForm();
      if (!form) return;

      var input = sellingPlanInput;
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.setAttribute('data-supplement-selling-plan', '');
        input.setAttribute('form', formId || form.id);
        root.appendChild(input);
        sellingPlanInput = input;
      }

      if (mode === 'subscribe' && planId) {
        input.value = String(planId);
        input.disabled = false;
        if (formId) input.setAttribute('form', formId);
      } else {
        input.value = '';
        input.disabled = true;
      }
    }

    function getPricesForVariant(variantId) {
      var v = variantMap[String(variantId)];
      if (!v) return null;

      var onetime = v.price;
      var compare = v.compare_at_price > onetime ? v.compare_at_price : 0;
      var subscribe = null;
      var planId = config.defaultSellingPlanId || null;

      // Only ever price a subscription from a real Shopify selling plan allocation.
      // Without one there is no plan to submit, so showing a discount would display
      // a price the checkout will not honour.
      if (v.allocations && v.allocations.length) {
        var alloc = v.allocations[0];
        subscribe = alloc.price;
        planId = alloc.selling_plan_id;
      }

      return {
        onetime: onetime,
        compare: compare,
        subscribe: subscribe,
        planId: planId,
      };
    }

    function renderPrices(variantId) {
      var prices = getPricesForVariant(variantId);
      if (!prices || !priceEl) return;

      var active = mode === 'subscribe' && prices.subscribe != null ? prices.subscribe : prices.onetime;
      priceEl.textContent = formatMoney(active, moneyFormat);
      priceEl.classList.toggle('supplement-product-form__price--subscribe', mode === 'subscribe');

      if (compareEl) {
        var showCompare = mode === 'subscribe' ? prices.onetime : prices.compare;
        if (showCompare && showCompare > active) {
          compareEl.textContent = formatMoney(showCompare, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (badgeSave) {
        badgeSave.hidden = mode !== 'subscribe' || prices.subscribe == null;
      }

      syncSellingPlanInput(mode === 'subscribe' ? prices.planId : null);
    }

    function setMode(next) {
      mode = next;
      toggleOnetime?.classList.toggle('supplement-product-form__toggle-btn--active', mode === 'onetime');
      toggleSubscribe?.classList.toggle('supplement-product-form__toggle-btn--active', mode === 'subscribe');
      toggleOnetime?.setAttribute('aria-pressed', mode === 'onetime' ? 'true' : 'false');
      toggleSubscribe?.setAttribute('aria-pressed', mode === 'subscribe' ? 'true' : 'false');
      renderPrices(currentVariantId);
    }

    toggleOnetime?.addEventListener('click', function () {
      setMode('onetime');
    });
    toggleSubscribe?.addEventListener('click', function () {
      setMode('subscribe');
    });

    document.addEventListener(VARIANT_UPDATE, function (event) {
      var detail = event.detail;
      if (!detail || !detail.resource) return;
      if (detail.data && detail.data.productId && String(detail.data.productId) !== productId) return;

      var section = root.closest('[id^="shopify-section-"]');
      if (section && detail.data && detail.data.html) {
        var sourceId = detail.sourceId;
        if (sourceId && !section.contains(document.getElementById(sourceId))) return;
      }

      currentVariantId = detail.resource.id;
      renderPrices(currentVariantId);
    });

    setMode(config.defaultMode || 'onetime');
    initBadges(root);
    initMagneticAtc(root);
  }

  function initBadges(root) {
    var badges = root.querySelectorAll('[data-supplement-badge]');
    if (!badges.length) return;

    if (!('IntersectionObserver' in window)) {
      badges.forEach(function (b) {
        b.classList.add('supplement-product-form__badge--in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('supplement-product-form__badge--in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
    );

    badges.forEach(function (badge) {
      observer.observe(badge);
    });
  }

  function initMagneticAtc(root) {
    var section = root.closest('.product-information');
    if (!section) return;

    var btn = section.querySelector('.add-to-cart-button');
    if (!btn) return;

    var strength = 10;

    btn.addEventListener('mousemove', function (e) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var rect = btn.getBoundingClientRect();
      var x = e.clientX - rect.left - rect.width / 2;
      var y = e.clientY - rect.top - rect.height / 2;
      btn.style.transform = 'translate(' + (x / strength) + 'px, ' + (y / strength - 2) + 'px)';
    });

    btn.addEventListener('mouseleave', function () {
      btn.style.transform = '';
    });
  }

  function initCartDrawerBoost() {
    document.addEventListener(CART_UPDATE, function () {
      var dialog = document.querySelector('.cart-drawer__dialog');
      if (!dialog) return;
      dialog.classList.add('supplement-cart-drawer--boost');
      window.setTimeout(function () {
        dialog.classList.remove('supplement-cart-drawer--boost');
      }, 500);
    });
  }

  function boot() {
    document.querySelectorAll('[data-supplement-product-form]').forEach(initRoot);
    initCartDrawerBoost();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
